(() => {
  if (window.atelierPolicyLoaded) return;
  window.atelierPolicyLoaded = true;
  const endpoint = 'https://udrrkckxysjzigwvzpyx.supabase.co/functions/v1/storefront-policy?slug=castlesonde';
  const update = async () => {
    const policyPage = document.querySelector('[data-atelier-policy]');
    const status = policyPage?.querySelector('[data-policy-status]');
    try {
      const response = await fetch(endpoint, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Policy unavailable');
      const policy = await response.json();
      if (policy.version !== 1 || policy.slug !== 'castlesonde' || !Array.isArray(policy.sections)) throw new Error('Invalid policy');
      document.querySelectorAll('[data-policy-exchange-summary]').forEach(node => { node.textContent = policy.exchangeSummary; });
      const delivery = policy.inStockDelivery;
      const valid = delivery?.unit === 'working_days' && delivery.startsFrom === 'order_date' && Number.isInteger(delivery.minDays) && Number.isInteger(delivery.maxDays) && delivery.minDays >= 1 && delivery.maxDays >= delivery.minDays && delivery.maxDays <= 30;
      window.atelierInStockDelivery = valid ? delivery : null;
      document.querySelectorAll('[data-policy-in-stock-delivery]').forEach(node => {
        node.textContent = valid ? `Lieferung in ${delivery.minDays}-${delivery.maxDays} Werktagen` : 'Auf Lager';
        node.setAttribute('aria-label', node.textContent);
      });
      document.dispatchEvent(new CustomEvent('atelier:policy-ready'));
      if (!policyPage) return;
      const fragment = document.createDocumentFragment();
      const ids = ['policy-shipping', 'policy-returns', 'policy-exchanges'];
      policy.sections.forEach((item, index) => {
        if (typeof item.title !== 'string' || !Array.isArray(item.paragraphs) || item.paragraphs.some(text => typeof text !== 'string')) throw new Error('Invalid policy section');
        const section = document.createElement('section');
        section.id = ids[index] || `policy-section-${index}`;
        const heading = document.createElement('h2');
        heading.textContent = item.title;
        section.append(heading);
        item.paragraphs.forEach(text => {
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          section.append(paragraph);
        });
        fragment.append(section);
      });
      policyPage.querySelector('[data-policy-content]').replaceChildren(fragment);
      status.textContent = '';
    } catch {
      if (status) status.textContent = 'Die aktuellen Bedingungen sind vorübergehend nicht verfügbar. Bitte kontaktiere uns zu den Bedingungen deiner Bestellung. Du kannst deine Bestellung auch im Retourenportal öffnen.';
    }
  };
  update();
  document.addEventListener('shopify:section:load', update);
})();